<template>
    <div>
        <div class="flex" style="margin-bottom: 10px">
            <!-- 选择排序 -->
            <Select
                style="width: 200px; margin-right: 15px"
                v-model="filter.orderBys"
                placeholder="排序类型"
                clearable
                @on-change="search"
            >
                <Option
                    v-for="item in orderBysList"
                    :value="item.id"
                    :key="item.id"
                >
                    {{ item.text }}
                </Option>
            </Select>
            <!-- 高级搜索 -->
            <room-adv-search
                v-model="advFilter"
                :channelType="channelType"
                ref="adv"
                @confirm="onAdvConfirm"
            />
        </div>
        <!-- 已选中的搜索条件 -->
        <select-tags
            v-model="advOptions"
            style="margin-bottom: 10px"
            @close="onAdvItemClose"
        />
        <!-- 表格工具栏 -->
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="请输入房源名称搜索"
                    style="margin-left: 10px"
                    @search="search"
                />
            </template>
            <Button
                v-if="$can('update')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickBatchUpdate"
            >
                批量修改
            </Button>
            <Button
                v-if="$can('update')"
                :class="preCls + 'button-margin'"
                :disabled="loading || !canPublish"
                @click="onClickBatchPublish"
            >
                批量上架
            </Button>
            <Button
                v-if="$can('update')"
                :class="preCls + 'button-margin'"
                :disabled="loading || !canUnPublish"
                @click="onClickBatchUnPublish"
            >
                批量下架
            </Button>
            <Button
                v-if="$can('exportExcel')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>

        <!-- 表格 -->
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
            @on-selection-change="onSelectChange"
        >
            <!-- 发布状态 -->
            <template #publishStatusText="{ row }">
                <span
                    :style="{
                        color: row.publishBtn == 1 ? '#02A7F0' : '#D9001B',
                    }"
                >
                    {{ row.publishStatusText }}
                </span>
            </template>
            <!-- 房间状态 -->
            <template #houseStatus="{ row }">
                <span
                    :style="{
                        color:
                            row.houseStatus == 1
                                ? '#D9001B'
                                : row.houseStatus == 2
                                ? '#02A7F0'
                                : row.houseStatus == 3
                                ? '#02A7F0'
                                : 'black',
                    }"
                >
                    {{ row.houseStatusText }}
                </span>
            </template>
            <!-- 房间图片 -->
            <template #attachments="{ row }">
                <div style="font-size: 0">
                    <base-img
                        v-for="(src, index) in row.imgList.slice(0, 4)"
                        :src="src"
                        :key="index"
                        style="margin: 2px"
                        width="44px"
                        height="44px"
                    >
                    </base-img>
                </div>
            </template>
            <!-- 操作列 -->
            <template #action="{ row }">
                <Button
                    v-if="$can('view')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="onRowClickInfo(row)"
                >
                    详情
                </Button>
                <Button
                    v-if="$can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="onRowClickUpdate(row)"
                >
                    修改
                </Button>
                <Button
                    v-if="$can('update') && row.publishBtn != '1'"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="onRowClickPublish(row)"
                >
                    上架
                </Button>
                <Button
                    v-if="$can('update') && row.publishBtn == '1'"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="onRowClickUnPublish(row)"
                >
                    下架
                </Button>
            </template>
        </Table>

        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            placement="top"
            @change="fetch"
        />

        <!-- 批量修改房间 -->
        <smart-modal
            v-model="modal.showRoomBatchEditForm"
            title="批量修改房间"
            :width="1080"
            :height="680"
            :maskClosable="false"
        >
            <room-batch-edit-form
                v-if="modal.showRoomBatchEditForm"
                :defaultHouseIds="curId"
                houseStatus="1"
                @search="search"
            />
        </smart-modal>
        <!-- 批量上/下架 -->
        <smart-modal
            v-model="modal.showRoomPublish"
            :title="
                (rowPublish ? '批量' : '') + (curUnPublish ? '下架' : '上架')
            "
            :width="960"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <room-publish
                v-if="modal.showRoomPublish"
                :defaultHouseList="defaultHouseList"
                :unPublish="curUnPublish"
                :curChannel="channelType"
            />
        </smart-modal>

        <!-- 房间详情修改 -->
        <smart-modal
            v-model="modal.showRoomForm"
            :title="actionTitle + '房间'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <room-form
                v-if="modal.showRoomForm"
                :id="curId"
                :form-mode="formMode"
                :channelType="channelType"
                enablePublishRules
            />
        </smart-modal>
    </div>
</template>

<script>
import mRentList from './m-rent-list'
import { mapCache } from '_g/vux-data-cache'
import { currency, getPublicImgUrls, ymdL } from '_u/helper'
import { marketRoomList } from '@/api/assets'
import RoomBatchEditForm from '_v/assets/park/room-batch-edit-form'
import RoomPublish from './room-publish'
import RoomForm from '_v/assets/park/room-form'

export default {
    name: 'room-rent-list',
    mixins: [mRentList],
    components: {
        RoomBatchEditForm,
        RoomPublish,
        RoomForm,
    },

    computed: {
        ...mapCache({
            filter: 'rentFilter',
            advFilter: 'rentAdvFilter',
            advOptions: 'rentAdvOptions',
        }),

        columns() {
            let list = [
                { type: 'selection', width: 60, align: 'center' },
                {
                    type: 'index',
                    width: 60,
                    title: '序号',
                    align: 'center',
                },
                {
                    key: 'houseName',
                    minWidth: 140,
                    title: '房源名称',
                },
                {
                    key: 'publishStatusText',
                    width: 90,
                    title: '发布状态',
                    align: 'center',
                    slot: 'publishStatusText',
                },
                {
                    key: 'houseStatusText',
                    width: 90,
                    title: '房间状态',
                    align: 'center',
                    slot: 'houseStatus',
                },
                {
                    key: 'houseType',
                    width: 100,
                    title: '户型',
                    align: 'center',
                },
                {
                    key: 'rentTypeText',
                    width: 90,
                    title: '出租类型',
                    align: 'center',
                },
                {
                    key: 'buildArea',
                    width: 90,
                    title: '面积(m²)',
                    align: 'center',
                },
                {
                    key: 'rentText',
                    width: 90,
                    title: '月租金',
                    align: 'center',
                },
                {
                    key: 'attachments',
                    minWidth: 220,
                    title: '房间图片',
                    // align: 'center',
                    slot: 'attachments',
                },
                {
                    minWidth: 180,
                    title: '操作',
                    align: 'center',
                    slot: 'action',
                    fixed: 'right',
                },
            ]

            // 渠道为出房 1 添加佣金
            if (this.channelType == 1) {
                list.splice(
                    -2,
                    0,
                    {
                        key: 'commissionText',
                        width: 90,
                        title: '佣金',
                        align: 'center',
                    },
                    {
                        key: 'commissionRemark',
                        minWidth: 100,
                        title: '佣金说明',
                        ellipsis: true,
                    }
                )
            }

            return list
        },

        canBatchUpdate() {
            return (
                // 不能包含已上架房间
                this.selection.every((v) => v.publishBtn != '1')
            )
        },
        canPublish() {
            return (
                this.selection.length > 0 &&
                // 不能包含已上架房间
                this.selection.every((v) => v.publishBtn != '1')
            )
        },
        canUnPublish() {
            return (
                this.selection.length > 0 &&
                // 只能是已上架房间
                this.selection.every((v) => v.publishBtn == '1')
            )
        },
    },

    props: {
        // 渠道类型
        channelType: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            loading: false,
            mtHeight: 360,
            selection: [],
            defaultHouseList: [],
            curId: '',
            curUnPublish: false,
            rowPublish: false,

            page: {
                total: 0,
                list: [],
            },
            dict: {
                parkType: this.$dict.NULL,
                decorationType: this.$dict.NULL,
                rentTypeNew: this.$dict.NULL,
                orientation: this.$dict.NULL,
                houseTag: this.$dict.NULL,
                publishStatus: this.$dict.NULL,
                houseStatus: this.$dict.NULL,
            },

            modal: {
                showRoomBatchEditForm: false,
                showRoomForm: false,
                showRoomPublish: false,
                showRoomSingPublish: false,
            },
        }
    },

    methods: {
        // 查询
        fetch() {
            this.loading = true
            return Promise.all([
                this.$dict.get([
                    'park_type',
                    'decoration_type',
                    'rent_type_new',
                    'orientation',
                    'house_tag',
                    'publish_status',
                    'house_status',
                ]),
                marketRoomList(
                    Object.assign(
                        {},
                        this.filter,
                        this.normalizeAdvFilter(this.advFilter)
                    )
                ),
            ])
                .then((args) => {
                    var [group, rooms] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = group[name]
                    })

                    this.setPageData(rooms.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 搜索
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        // 设置分页数据
        setPageData(data) {
            var list = data.page.list

            list.forEach((v) => {
                var factitleList = v.factitle ? v.factitle.split([',']) : []

                v.rentText = currency(v.rent)
                v.commissionText = currency(v.commission)
                v.rentTypeText = this.dict.rentTypeNew.val(v.rentType)
                v.orientationText = this.dict.orientation.val(v.orientation)
                v.factitleText =
                    factitleList.length > 2
                        ? factitleList.slice(0, 2).join(',') +
                          '等' +
                          factitleList.length +
                          '个'
                        : factitleList.slice(0, 2).join(',')
                v.houseStatusText = this.dict.houseStatus.val(v.houseStatus)
                v.imgList = getPublicImgUrls(v.attachments)
                // 上下架按钮  1->出房->publishStatus  2->找房->zwzhaoPublishStatus
                v.publishBtn =
                    this.channelType == 1
                        ? v.publishStatus
                        : v.zwzhaoPublishStatus
                // 上架状态
                v.publishStatusText =
                    this.dict.publishStatus.val(v.publishBtn) || '待上架'
            })

            this.page.list = list
            this.page.total = parseInt(data.page.totalCount)
        },

        // 批量修改
        onClickBatchUpdate() {
            this.modal.showRoomBatchEditForm = true
        },
        // 批量上架
        onClickBatchPublish() {
            this.defaultHouseList = this.selection
            this.curUnPublish = false
            this.rowPublish = true
            this.modal.showRoomPublish = true
        },
        // 批量下架
        onClickBatchUnPublish() {
            this.defaultHouseList = this.selection
            this.curUnPublish = true
            this.rowPublish = true
            this.modal.showRoomPublish = true
        },
        // 行勾选
        onSelectChange(selection) {
            this.selection = selection
        },

        // 查看详情
        onRowClickInfo(row) {
            this.curId = row.id
            this.formMode = this.FORM_MODE.view
            this.modal.showRoomForm = true
        },
        // 房源编辑
        onRowClickUpdate(row) {
            this.curId = row.id
            this.formMode = this.FORM_MODE.update
            this.modal.showRoomForm = true
        },
        // 行上架
        onRowClickPublish(row) {
            this.defaultHouseList = [row]
            this.curUnPublish = false
            this.rowPublish = false
            this.modal.showRoomPublish = true
        },
        // 行下架
        onRowClickUnPublish(row) {
            this.defaultHouseList = [row]
            this.curUnPublish = true
            this.rowPublish = false
            this.modal.showRoomPublish = true
        },
        // 导出数据处理
        onClickExport() {
            this.$refs.mt.exportToExcel({
                filename: '数据表',
                index: true,
                rows: this.page.list.map((data, index) => {
                    let pageData = Object.assign({}, data)
                    pageData.attachments = ''

                    return pageData
                }),
            })
        },
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                60
        })
    },

    created() {
        // 清除筛选
        this.advOptions = []
        this.advFilter = {}

        this.fetch()
    },
}
</script>

<style lang="less" scoped></style>
